import Vue from 'vue'
import Router from 'vue-router'

//页面
import Index from '@/pages/index/index'
import Search from '@/pages/search/index'
import Contact from '@/pages/contact/index'
import About from '@/pages/about/index'
import News from '@/pages/news/index'
import NewsInfo from '@/pages/news/info'
import Product from '@/pages/products/index'
import ProductInfo from '@/pages/products/info'

Vue.use(Router);

export default new Router({
	mode: 'history',
	scrollBehavior(to, from, savePosition) {
		if(savePosition){
			return savePosition
		}else{
			return { x: 0, y: 0 }
		}
	},
	// base: process.env.NODE_ENV === "production" ? "/en/" : "/",
	routes: [
		{
		  path: '*',
		  redirect: '/'
		},{
			path: '/',
			name: 'Index',  //主页
			component: Index,
			meta: {
				requireAuth: true
			}
		},{
			path: '/search.html',
			name: 'Search',  //搜索
			component: Search,
			meta: {
				requireAuth: true
			}
		},{
			path: '/contact.html',
			name: 'Contact',  //联系我们
			component: Contact,
			meta: {
				requireAuth: true
			}
		},{
			path: '/about/:aboutId',
			name: 'About',  //关于我们
			component: resolve => require(['@/pages/about/index'], resolve), 
			meta: {
				requireAuth: true
			}
		},{
			path: '/news/:newsId',
			name: 'News',  //新闻资讯
			component: resolve => require(['@/pages/news/index'], resolve), 
			meta: {
				requireAuth: true
			}
		},{
			path: '/news-info/:newInfoId',
			name: 'NewsInfo',  //新闻资讯详情
			component: NewsInfo,
			meta: {
				requireAuth: true
			}
		},{
			path: '/product.html',
			name: 'Product',  //产品中心
			component: Product,
			meta: {
				requireAuth: true
			}
		},{
			path: '/product-info/:productInfoId',
			name: 'ProductInfo',  //产品详情
			component: ProductInfo,
			meta: {
				requireAuth: true
			}
		}
	]
})